var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiche(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.168,
    height: 57.085,
    viewBox: "0 0 40.168 57.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0082de;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.78 -2.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.083,59.086a.865.865,0,0,0,.865-.865V17.2A3.355,3.355,0,0,0,48.6,13.85h-3.4a7.774,7.774,0,0,0-6.7-5.829A6.658,6.658,0,0,0,27.7,3.46a6.641,6.641,0,0,0-2.476,4.563,7.777,7.777,0,0,0-6.687,5.827h-3.4A3.355,3.355,0,0,0,11.78,17.2v41.02a.865.865,0,0,0,.865.865ZM26.056,9.708a.865.865,0,0,0,.865-.865v-.17A4.924,4.924,0,0,1,28.779,4.81a4.939,4.939,0,0,1,8.028,3.97v.062a.865.865,0,0,0,.865.865A6.038,6.038,0,0,1,43.7,15.74v.125H20.025V15.74A6.038,6.038,0,0,1,26.056,9.708ZM13.51,17.2a1.623,1.623,0,0,1,1.622-1.622H18.3c0,.054-.008.106-.008.16v.99a.865.865,0,0,0,.865.865H44.568a.865.865,0,0,0,.865-.865v-.99c0-.054-.006-.106-.008-.16H48.6A1.623,1.623,0,0,1,50.218,17.2V57.357H13.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.495,13.127a3.244,3.244,0,1,0-3.244-3.244A3.247,3.247,0,0,0,34.495,13.127Zm0-4.757a1.514,1.514,0,1,1-1.514,1.514A1.515,1.515,0,0,1,34.495,8.37Z",
    transform: "translate(-2.63 -0.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.967,44.587A7.528,7.528,0,1,0,41.5,52.115,7.536,7.536,0,0,0,33.967,44.587Zm0,13.326a5.8,5.8,0,1,1,5.8-5.8A5.8,5.8,0,0,1,33.967,57.913Z",
    transform: "translate(-1.98 -5.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.289,49.7l-4.31,4.31-1.323-1.323a.865.865,0,0,0-1.223,1.223l1.934,1.935a.864.864,0,0,0,1.223,0l4.922-4.922A.865.865,0,1,0,37.289,49.7Z",
    transform: "translate(-2.485 -6.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.653,25.766H41.646a.865.865,0,1,0,0-1.73H20.653a.865.865,0,0,0,0,1.73Z",
    transform: "translate(-1.082 -2.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.653,33.2h17.4a.865.865,0,1,0,0-1.73h-17.4a.865.865,0,1,0,0,1.73Z",
    transform: "translate(-1.082 -3.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.238,38.9H20.653a.865.865,0,0,0,0,1.73H45.238a.865.865,0,1,0,0-1.73Z",
    transform: "translate(-1.082 -4.983)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiche);
export default __webpack_public_path__ + "static/media/fiche.228e04b009216facc03ee9cdc4cfaece.svg";
export { ForwardRef as ReactComponent };